import React from "react";
import { Link, useParams } from "react-router";
import { useTemplate } from "../../hooks/useTemplates";
import AuditInfo from "../../components/ui/AuditInfo";
import { auditApi } from "../../services/api";

export default function TemplateDetailPage() {
  const { templateId } = useParams<{ templateId: string }>();
  const id = Number(templateId);
  const { data, isLoading, isError } = useTemplate(id);

  if (isLoading) return <div className="p-8">Loading…</div>;
  if (isError || !data) return <div className="p-8">Not found</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Template: {data.name}</h1>
        <Link
          className="px-3 py-2 bg-blue-600 text-white rounded"
          to={`/templates/${id}/edit`}
        >
          Edit
        </Link>
      </div>

      <div className="bg-white p-4 rounded shadow">
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <dt className="text-sm text-gray-500">Type</dt>
            <dd className="text-sm font-medium">{data.template_type}</dd>
          </div>
          <div>
            <dt className="text-sm text-gray-500">Subject</dt>
            <dd className="text-sm font-medium">{data.subject || "-"}</dd>
          </div>
          <div>
            <dt className="text-sm text-gray-500">Provider Code</dt>
            <dd className="text-sm font-medium">
              {data.provider_template_code || "-"}
            </dd>
          </div>
          <div>
            <dt className="text-sm text-gray-500">Delayed Minutes</dt>
            <dd className="text-sm font-medium">
              {data.delayed_send_minutes ?? "-"}
            </dd>
          </div>
          <div className="md:col-span-2">
            <dt className="text-sm text-gray-500 mb-1">Content</dt>
            <pre className="p-3 bg-gray-50 rounded overflow-auto text-sm whitespace-pre-wrap">
              {data.content || ""}
            </pre>
          </div>
        </dl>
      </div>

      {id ? (
        <AuditInfo
          resource="templates"
          id={id}
          fetch={auditApi.getLastChange}
        />
      ) : null}
    </div>
  );
}
